import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
// import Splash from "../pages/splash";
import Password from '../pages/auth/password';
import Register from '../pages/auth/register';
import Otp from '../pages/auth/otp';
import Login from '../pages/auth/login';
import Profile from '../pages/profile';
import ChangePassword from '../pages/profile/changePassword';
import Reports from '../pages/reports';
import Missions from '../pages/missions';
import EditProfile from '../pages/profile/edit';
import sendBackRoutes from '../components/sendBackRoutes/index';

export function RouterComponent() {
  let info;
  try {
    info = JSON.parse(localStorage?.getItem('info'));
  } catch (e) {
    info = null;
  }
  const isAuthenticated = info?.token;
  const homePath = ['/', '/login', '/missions'];

  useEffect(() => {
    sendBackRoutes(homePath);
  }, []);

  return (
    <>
      {isAuthenticated ? (
        <Routes>
          <Route path="/" element={<Missions />} />
          <Route path="missions" element={<Missions />} />
          <Route path="reports" element={<Reports />} />
          <Route path="*" element={<Missions />} exact />
          <Route path="profile" element={<Profile />} />
          <Route path="/profile/change-password" element={<ChangePassword />} />
          <Route path="/profile/edit" element={<EditProfile />} />
        </Routes>
      ) : (
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/password" element={<Password />} />
          <Route path="/otp" element={<Otp />} />
          <Route path="/register" element={<Register />} />
          <Route path="*" element={<Login />} exact />
        </Routes>
      )}
    </>
  );
}
